import React, { useState } from "react";
import play from "../../assets/icons/play.webp";
import CustomInput from "../CustomInput";
import { createTutorial } from "../../services/tutorials";
import Select from "../Select";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../ui-elements/Notification";

const categoryOptions = [
  { text: "Crecimiento", value: "growth" },
  { text: "Floración", value: "flowering" },
  { text: "Descanso", value: "resting" },
  { text: "Cuidado", value: "care" },
  { text: "Alimentación", value: "feeding" },
  { text: "Cualquiera", value: "any" },
];

const validateUrl = (value) => {
  //validar urls de youtube
  //necesario para videos embebidos de youtube
  try {
    // Intenta crear un objeto URL
    const url = new URL(value);

    // Expresión regular para verificar si la URL es de YouTube
    const youtubeRegex =
      /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;

    // Verifica si la URL es válida y si es de YouTube
    if (youtubeRegex.test(url.href)) {
      return true; // Es una URL de YouTube válida
    } else {
      return false; // No es una URL de YouTube válida
    }
  } catch (e) {
    return false; // No es una URL válida
  }
};

const convertToEmbedUrl = (url) => {
  // Si la URL es de YouTube, la convertimos a la versión de iframe
  const youtubeRegex =
    /(?:https?:\/\/(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]*\S+v=|v\/|(?:\/(?:v|e(?:mbed)?)\/))|youtu\.be\/))([A-Za-z0-9_-]{11})/;
  const match = url.match(youtubeRegex);

  if (match && match[1]) {
    // Devuelve la URL embebida del video de YouTube
    return `https://www.youtube.com/embed/${match[1]}`;
  }
  return url; // Si no es una URL de YouTube, devolvemos la URL original
};

const AddTutorialModal = ({ uploadParentArr, handleClose }) => {
  const [description, setDescription] = useState("");
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [timeSeconds, setTimeSeconds] = useState(""); //valdar gfomr != null
  const [timeMinutes, setTimeMinutes] = useState("");
  const [uploading, setUploading] = useState(false);
  const [category, setCategory] = useState("");

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };
  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };
  const handleUrlChange = (event) => {
    setUrl(event.target.value);
  };
  const handleSecondsChange = (event) => {
    if (event.target.value >= 0) setTimeSeconds(event.target.value);
    else setTimeSeconds(null);
  };
  const handleMinutesChange = (event) => {
    if (event.target.value >= 0 && event.target.value <= 59)
      setTimeMinutes(event.target.value);
    else setTimeMinutes(null);
  };

  const handleSumbit = (e) => {
    e.preventDefault();
    if (
      validateUrl(url) &&
      title != "" &&
      category != "" &&
      timeMinutes != "" &&
      timeSeconds != ""
    ) {
      const uploadVideo = async () => {
        try {
          setUploading(true);

          const embedUrl = convertToEmbedUrl(url);

          let props = {
            title: title,
            url: embedUrl,
            minutes: timeMinutes,
            seconds: timeSeconds,
            category: category,
          };
          if (description != "") props.description = description;
          const { message, doc } = await createTutorial(props);
          uploadParentArr(doc);
          setUploading(false);
          Notification({
            title: "Operación completada",
            text: `${message}`,
            type: "Success",
          });
          handleClose();
        } catch (err) {
          IS_LOCAL_ENV && console.error(err);
          setUploading(false);
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
        }
      };
      uploadVideo();
    } else {
      Notification({
        title: "Operación inválida",
        text: `Ingrese un url válido o completa todos los campos`,
        type: "Error",
      });
    }
  };

  return (
    <>
      <div className="w-full pl-4 pr-6 pb-2 flex flex-row h-full items-center">
        <div className="w-fit flex items-center ">
          <img src={play} className="w-[55px] " />
        </div>
        <div className="flex pl-2">
          <h1 className="text-black font-poppins text-2xl font-bold ">
            Añade un nuevo video
          </h1>
        </div>
      </div>
      <form className=" flex p-1 flex-col w-full items-center">
        <CustomInput
          title={"Título"}
          value={title}
          onChange={handleTitleChange}
          placeholder="Cómo alimentar a tu planta"
          inputType="text"
          required={true}
        />
        <CustomInput
          title={"Descripción"}
          value={description}
          onChange={handleDescriptionChange}
          placeholder="Paso a paso de como alimentar a tu planta"
          inputType="textarea"
        />
        <CustomInput
          title={"URL"}
          value={url}
          onChange={handleUrlChange}
          placeholder="video.com"
          inputType="text"
          required={true}
        />
        <div className="flex flex-wrap justify-start w-full h-full ">
          <CustomInput
            title={"Duración del video"}
            value={timeMinutes}
            onChange={handleMinutesChange}
            value2={timeSeconds}
            onChange2={handleSecondsChange}
            placeholder="7:34"
            inputType="duration"
            required={true}
            customMaxW="max-w-[240px]"
          />
          <CustomInput
            title="Categoría"
            inputType="select"
            customMaxW={"max-w-[220px]"}
            selectProps={{
              options: categoryOptions,
              value: category,
              setValue: (e) => setCategory(e.target.value),
              isTableSelect: true,
              placeholder: "Categoría",
              required: true,
              isInputChild: true,
            }}
            required={true}
          />
          {/* <div className="mt-[3px] h-full w-full ">
            <span className="font-poppins font-bold text-dark-green mb-2">
              Categoría *
            </span>
            <Select
              className="w-fit"
              options={categoryOptions}
              value={category}
              setValue={(e) => {
                setCategory(e.target.option);
              }}
              isTableSelect={true}
              placeholder="Categoría"
              required={true}
            />
          </div> */}
        </div>

        <button
          className={` w-fit bg-dark-green text-xl  rounded-full py-4 px-8 text-white ${
            uploading
              ? "bg-default-gray cursor-not-allowed"
              : "bg-dark-green hover:bg-accent-green"
          } transition-all duration-100 font-bold font-poppins`}
          type="submit"
          onClick={handleSumbit}
          disabled={uploading}
        >
          Añadir
        </button>
      </form>
    </>
  );
};

export default AddTutorialModal;
